require('../../templates/paragraphs/certificate-finder/certificate-finder.jquery');
